<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Forecast"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-lg-12">
		<div class="card" id="blackoutDaysList">
			<div class="card-header border-0">
				<div class="d-flex align-items-center">
					<h5 class="card-title mb-0 flex-grow-1">
						Forecasting leads in monthly periods
					</h5>
				</div>
			</div>
			<div
				class="card-body border border-dashed border-end-0 border-start-0"
			>
				<div class="margin-top-2">
					<!-- Nav tabs -->
					<ul
						ngbNav
						#nav="ngbNav"
						[activeId]="1"
						class="nav nav-tabs nav-tabs-custom nav-success mb-3"
					>
						<li [ngbNavItem]="1">
							<a ngbNavLink>
								<i
									class="ri-calendar-2-fill me-1 align-bottom"
								></i>
								Real Leads
							</a>
							<ng-template ngbNavContent>
								<app-real-month></app-real-month>
							</ng-template>
						</li>

						<!-- <li [ngbNavItem]="2">
							<a ngbNavLink>
							  <i class="ri-calendar-2-fill me-1 align-bottom"></i> Monthly Forecast
							</a>
							<ng-template ngbNavContent>
								<app-forecast-month></app-forecast-month>
							</ng-template>
						</li> -->

						<!-- <li [ngbNavItem]="3">
							<a ngbNavLink>
							  <i class="ri-calendar-2-fill me-1 align-bottom"></i> Comparative Report
							</a>
							<ng-template ngbNavContent>
								<app-comparative-month></app-comparative-month>
							</ng-template>
						</li> -->
					</ul>

					<!-- Tab panes -->
					<div class="tab-content text-muted">
						<div [ngbNavOutlet]="nav"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
